import {keyframes, styled} from "@connectme2/ui";

const firstDotAnimation = keyframes`
    0% {
        left: 5rem;
        top: 4rem;
    }
    20% {
        left: 8.5rem;
        top: 8.5rem;
    }
    40% {
        left: 4rem;
        top: 8.5rem;
    }
    60% {
        left: 0.5rem;
        top: 8.5rem;
    }
    80% {
        left: 5rem;
        top: 4rem;
    }
    100% {
        left: 5rem;
        top: 4rem;
    }
`;

const secondDotAnimation = keyframes`
    0% {
        left: 3rem;
        top: 5.5rem;
    }
    20% {
        left: 0.5rem;
        top: 8.5rem;
    }
    40% {
        left: 0.5rem;
        top: 0.5rem;
    }
    60% {
        left: 4rem;
        top: 0.5rem;
    }
    80% {
        left: 5rem;
        top: 4rem;
    }
    100% {
        left: 5rem;
        top: 4rem;
    }
`;

const thirdDotAnimation = keyframes`
    0% {
        left: 5rem;
        top: 4rem;
    }
    20% {
        left: 4.5rem;
        top: 0.5rem;
    }
    40% {
        left: 8.5rem;
        top: 0.5rem;
    }
    60% {
        left: 8.5rem;
        top: 8.5rem;
    }
    80% {
        left: 5rem;
        top: 4rem;
    }
    100% {
        left: 5rem;
        top: 4rem;
    }
`;

const Base = styled.div`
    width: 3.75rem;
    height: 3.75rem;
    border-radius: 50%;
    animation-duration: 4s;
    animation-iteration-count: infinite;
`;

export const FirstDot = styled(Base)`
    background-color: ${({theme}) => theme.figure.primary};
    animation-name: ${firstDotAnimation};
    position: relative;
`;

export const SecondDot = styled(Base)`
    background-color: ${({theme}) => theme.figure.secondary};
    animation-name: ${secondDotAnimation};
    position: absolute;
`;

export const ThirdDot = styled(Base)`
    background-color: ${({theme}) => theme.figure.tertiary};
    animation-name: ${thirdDotAnimation};
    position: absolute;
`;
